import React, { useCallback } from 'react';
import { getSortConfig, sortProducts } from '../../utils';

import { miniGazelle } from '../../../../../helpers';

const SortSection = ({ products, sortByProp, setProducts }) => {
    const handleSortEvent = useCallback(e => {
        const value = e.target.value;
        const sortConfig = getSortConfig(value);

        if (sortConfig) {
            const { field, reverse, primer } = sortConfig;
            const sortedProducts = sortProducts(products, field, reverse, primer);
            setProducts(sortedProducts);
        } else {
            setProducts(products);
        }
    });

    return (
        <div className="sort-wrapper" data-testid="sort-section">
            <form className="form-inline">
                <div className="form-group">
                    <label className="sr-only">{miniGazelle.label('sortLabel', true)}</label>
                    <div className="select-wrapper">
                        <select
                            className="form-control"
                            defaultValue="none"
                            onChange={handleSortEvent}
                            aria-label="Sort by dropdown"
                        >
                            <option value="none" disabled>
                                {miniGazelle.label('sortLabel', true)}
                            </option>
                            {sortByProp.map((sortType, i) => (
                                <option key={i} value={sortType} data-testid={`sort-${sortType}`}>
                                    {miniGazelle.label(`${sortType}SortFormLabel`, true)}
                                </option>
                            ))}
                        </select>
                        <div className="select-arrow icon icon-2x icon-down-arrows" aria-label="dropdown-arrows" />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default SortSection;
